<template>
  <div>
    <span class="money">￥{{ formatMoney }}</span>
  </div>
</template>

<script>
import { formatCurrency } from "@/util/index.js";
export default {
  props: {
    value: {
      default: 0,
    },
  },
  computed: {
    formatMoney() {
      return formatCurrency(Number(this.value), 2);
    },
  },
};
</script>

<style lang="less" scoped>
.money {
  font-size: 24px;
  font-weight: bold;
  color: #383a3d;
  line-height: 28px;
}
</style>